import React from 'react';

interface CardBaseProps {
  children: React.ReactNode;
  onClick: () => void;
  isSelected: boolean;
  selectedStyle: string;
  isWater?: boolean;
}

const CardBase: React.FC<CardBaseProps> = ({ children, onClick, isSelected, selectedStyle, isWater }) => {
  const pathD = isWater
    ? "M328 99.0003C328 128.824 303.823 153 274 153H54C24.1766 153 0 128.824 0 99.0003V0.439793C15.5951 10.9383 68.417 28.3887 154.944 14.2005C241.472 0.0122024 306.368 -0.885266 328 0.439793V99.0003Z"
    : "M328 99.0004C328 128.824 303.823 153 274 153H54C24.1767 153 0.000169454 128.824 0 99.0004V0.439895C15.5952 10.9384 68.4171 28.3878 154.944 14.1997C241.472 0.0113242 306.368 -0.885166 328 0.439895V99.0004Z";

  return (
    <div className="cursor-pointer relative w-80 h-[325px]" onClick={onClick}>
      <div className={`w-80 h-80 left-0 top-0 absolute bg-white rounded-[60px] ${isSelected ? selectedStyle : ''}`} />
      <div data-svg-wrapper data-layer="Union" className="Union left-0 top-[172px] absolute">
        <svg width="328" height="153" viewBox="0 0 328 153" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d={pathD} fill="#02B9B8"/>
        </svg>
      </div>
      {children}
    </div>
  );
};

export default CardBase;
